import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import ConfirmationDialog from "../components/dialogs/confirmation-dialog";
import FadeWrapper from "../components/fade-wrapper";
import LoadingDialog from "../components/dialogs/loading-dialog";

const propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export const DialogContext = createContext([]);

export const useDialogContext = () => useContext(DialogContext);

export const DialogProvider = ({ children }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [dialogOptions, setDialogOptions] = useState(null);
  const [animationState, setAnimationState] = useState("ENTERING");

  const openDialog = (options) => {
    setDialogOptions(options);
    setShowDialog(true);
  };

  const closeDialog = () => {
    setAnimationState("LEAVING");
    setTimeout(() => {
      setShowDialog(false);
      setDialogOptions(null);
      setAnimationState("ENTERING");
    }, 200);
  };

  const switchDialog = (options) => {
    switch (options.type) {
      case "loading":
        return <LoadingDialog {...options} />;
      default:
        return <ConfirmationDialog {...options} />;
    }
  };

  return (
    <DialogContext.Provider value={{ openDialog, closeDialog }}>
      {children}
      <div className="z-50">
        {showDialog && (
          <FadeWrapper
            className="w-full h-full fixed top-0 left-0 bg-black bg-opacity-25 z-50 flex justify-center items-center p-4"
            animationState={animationState}
          >
            {switchDialog(dialogOptions)}
          </FadeWrapper>
        )}
      </div>
    </DialogContext.Provider>
  );
};

DialogProvider.propTypes = propTypes;

export default DialogProvider;
